const getFilenameFromContentDisposition = str => {
  const regexp = /filename="(.*)"/gi;
  return regexp.exec(str)[1];
};

export default getFilenameFromContentDisposition;
